/* eslint prefer-destructuring: 0 */
/* eslint consistent-return: 0 */

/**
 * @ngdoc service
 * @name services.Util
 *
 * @description
 * System information helper functions
 */

angular.module('services')
    .factory('SystemInformation', () => ({
        disks: (diskInfo) => {

            angular.forEach(diskInfo, (disk) => {

                if (!disk.shortName && disk.name) {

                    const [shortName] = disk.name.match(/[\w]+/i);

                    switch (shortName.toLowerCase()) {

                    case 'intel':
                        disk.shortName = 'Intel';
                        if (disk.name.indexOf('SSD') !== -1) {

                            disk.type = 'SSD';

                        }
                        break;
                    case 'western':
                        disk.shortName = 'Western Digital';
                        break;
                    case 'vmware':
                        disk.shortName = 'VMware Virtual Disk';
                        break;
                    default:
                        disk.shortName = shortName || disk.name;

                    }

                }

            });
            return diskInfo;

        },

        cpu(cpu) {

            if (cpu && !cpu.shortName) {

                if (cpu.name) {

                    cpu.shortName = cpu.name.replace(/CPU|\(R\)|\(TM\)|@.+/g, '');

                }

            }

            return cpu;

        },

        motherboard(motherboard) {

            if (!motherboard) {

                return;

            }
            if (motherboard.brand && !motherboard.shortBrand) {

                motherboard.shortBrand = motherboard.brand.split(' ')[0];

            }

            if (motherboard.model && !motherboard.shortModel) {

                motherboard.shortModel = motherboard.model.replace(new RegExp(motherboard.shortBrand, 'gi'), '');

            }

            return motherboard;

        },

        resolution(resolution) {

            const sResolution = resolution ? resolution.match(/\d+x\d+/i) : '';

            return sResolution && sResolution[0];

        },
    }));



// WEBPACK FOOTER //
// ./scripts/common/services/util/SystemInformation.js